import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d6dda710"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-candidate-path" };
const _hoisted_2 = {
    key: 0,
    class: "separator"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1 /* HOISTED */));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "separator" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-right" })
], -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "ellipsis" }, "...", -1 /* HOISTED */));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "separator" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-angle-right" })
], -1 /* HOISTED */));
import { computed } from "vue";
import { useParentBuiltComponents } from "src/shared/store/component-graph/composables";
import ComponentDisplayName from "../ComponentDisplayName.vue";
import Tooltip from "../../ui/Tooltip.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentCandidatePath',
    props: {
        componentId: {}
    },
    setup(__props) {
        const props = __props;
        const parentBuiltComponents = useParentBuiltComponents(() => props.componentId);
        const breadcrumbComponents = computed(() => {
            return parentBuiltComponents.value
                .slice()
                .reverse()
                .filter((component) => !component.isRoot());
        });
        const fullPath = computed(() => {
            return breadcrumbComponents.value
                .map((component) => component.getDisplayName())
                .join(" > ");
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Tooltip, { message: fullPath.value }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (breadcrumbComponents.value.length <= 2)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(breadcrumbComponents.value, (component, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: component.id
                                }, [
                                    _createVNode(ComponentDisplayName, {
                                        "component-id": component.id,
                                        class: "component-name"
                                    }, null, 8 /* PROPS */, ["component-id"]),
                                    (index < breadcrumbComponents.value.length - 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */));
                            }), 128 /* KEYED_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(ComponentDisplayName, {
                                    "component-id": breadcrumbComponents.value[0].id,
                                    class: "component-name first"
                                }, null, 8 /* PROPS */, ["component-id"]),
                                _hoisted_5,
                                _hoisted_6,
                                _hoisted_7,
                                _createVNode(ComponentDisplayName, {
                                    "component-id": breadcrumbComponents.value[breadcrumbComponents.value.length - 1].id,
                                    class: "component-name last"
                                }, null, 8 /* PROPS */, ["component-id"])
                            ], 64 /* STABLE_FRAGMENT */))
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["message"]));
        };
    }
});
